import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'

export const PAYMENT_API = ShipbobAppSettings.PaymentApi.ApiBaseUrl

class PaymentServiceInternal {
  urls () {
    return {
      getProcessingFee: PAYMENT_API + 'paymentMethods/v1/processing-fee/',
      acknowledgeProcessingFee: PAYMENT_API + 'paymentMethods/processingFee/',
      getUserPaymentMethod: PAYMENT_API + 'v1/payment-methods'
    }
  }

  async getProcessingFeeConfiguration (currencyCode) {
    const request = {
      Url: `${this.urls().getProcessingFee}${currencyCode}`
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  async getUserPaymentMethods () {
    const request = {
      Url: `${this.urls().getUserPaymentMethod}`
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  async acknowledgeProcessingFee (cardTypeId) {
    const request = {
      Url: `${this.urls().acknowledgeProcessingFee}${cardTypeId}`
    }

    return await HttpWrapper.Post(request)
  }
}

export const PaymentService = new PaymentServiceInternal()
